import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=06f0a716&scoped=true&"
import script from "./ProfileEdit.js?vue&type=script&lang=js&"
export * from "./ProfileEdit.js?vue&type=script&lang=js&"
import style0 from "./ProfileEdit.scss?vue&type=style&index=0&id=06f0a716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0a716",
  null
  
)

export default component.exports